import React, { ReactElement, ReactNode, useContext, useEffect, useState } from 'react';
import getConfig from '../../common/configGateway';

export interface AppContext {
    window: Window;
    configState: {
        loading: boolean;
        error: boolean;
        config: {
            registrationUrl: string;
            pingAccessUrl: string;
        };
    };
}

const defaultConfigState = {
    loading: true,
    error: false,
    config: {
        registrationUrl: '',
        pingAccessUrl: '',
    },
};
export const appContext = React.createContext<AppContext>({
    window,
    configState: defaultConfigState,
});
export const useAppContext = (): AppContext => useContext(appContext);

export function AppContextProvider({
    children,
    currentWindow = window,
}: {
    children: ReactNode;
    currentWindow?: Window;
}): ReactElement {
    const [configState, setConfigState] = useState(defaultConfigState);

    useEffect(() => {
        const initializeConfig = async (): Promise<void> => {
            try {
                const config = await getConfig();
                setConfigState({ loading: false, error: false, config });
            } catch (_) {
                setConfigState({ ...defaultConfigState, error: true, loading: false });
            }
        };
        initializeConfig();
    }, []);

    return <appContext.Provider value={{ window: currentWindow, configState }}>{children}</appContext.Provider>;
}
